<template>
  <layout>
    <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
    <template v-if="books.length > 0">
      <transition name="fade">
        <div class="searchresult">
          <div class="books">
            <template v-for="book in books">
              <router-link :key="book.isbn" :to="`/book/${book.isbn}`">
                <div class="card">
                  <image-loader class="cover" :src="book.coverPath" />
                  <div class="bottombar">
                    <span class="title">{{ book.cnTitle }}</span>
                  </div>
                </div>
              </router-link>
            </template>
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <transition name="fade">
        <div class="content">
          <img class="logo" src="../assets/logo.png" alt="logo" />
          <div class="cs">
            <span class="iconfont iconsearch"></span>
            <input v-model="searchstr" type="text" @keydown="enter" />
          </div>
        </div>
      </transition>
    </template>
    <template v-slot:ft>
      <mfooter :elink="true"></mfooter>
    </template>
  </layout>
</template>

<script>
import IndexLayout from "./_layout/search_layout";
import Footer from "./Footer";
import { get } from "../libs/bookRequest";
import { bookAPI } from "../libs/consts";
import * as utils from "../libs/utils";

export default {
  name: "BookSearch",
  components: {
    layout: IndexLayout,
    mfooter: Footer,
  },
  data() {
    return {
      searchstr: this.querystr,
      loading: false,
      pgInd: 1,
      pgLen: 10,
      books: [],
      maxpages: 1,
    };
  },
  computed: {
    querystr() {
      return this.$route.query.str;
    },
  },
  created() {
    if (this.querystr) {
      this.search();
    }

    window.addEventListener("scroll", this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
  },
  methods: {
    enter(event) {
      console.log(event);
      if (event.code == "Enter") {
        this.$router.push(`/booksearch?str=${encodeURI(this.searchstr)}`);
      }
    },
    navto(book) {
      this.$router.push(`/book/${book.isbn}`);
    },
    search() {
      if (
        this.querystr.length == 0 ||
        this.loading == true ||
        this.pgInd > this.maxpages
      ) {
        return;
      }
      this.loading = true;
      get(bookAPI.book.books, {
        Name: this.querystr,
        PageIndex: this.pgInd,
        PageSize: this.pgLen,
      })
        .then((data) => {
          this.books.push(...data.items);
          this.pgInd++;
          this.maxpages = data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    scroll() {
      //window 1%的误差
      if (
        utils.scrollFix(utils.getScrollHeight()) ==
        utils.scrollFix(utils.getWindowHeight() + utils.getDocumentTop())
      ) {
        this.search();
      }
    },
  },
  watch: {
    querystr() {
      this.pgInd = 1;
      this.books = [];
      this.maxpages = 1;
      this.search();
    },
  },
};
</script>

<style scoped>
.logo {
  width: 2.2rem;
  height: 0.9rem;
}
.cs {
  position: relative;
  margin: 0 auto;
  margin-top: 0.2rem;
}

.cs input:focus {
  border-color: #409eff;
}

.cs input {
  height: 0.5rem;
  width: 6rem;
  height: 0.5rem;
  line-height: 0.4rem;
  border: 2px solid #848484;
  padding: 0.1rem 0.6rem;
  outline: none;
  border-radius: 0.5rem;
  font-size: 0.26rem;
  width: 5.8rem;
}
.iconsearch {
  font-size: 0.3rem;
  color: #777777;
  position: absolute;
  top: 0.2rem;
  left: 0.3rem;
}

.content {
  margin-top: 1.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.searchresult {
  /* margin-top: 0.8rem; */
  margin: 1.64rem 0;
  /* margin-bottom: 0.8rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: flex-start;
}

.resultcard {
  width: 12rem;
  height: 2rem;
  position: relative;
  border-bottom: 1px solid #979797;
}

.left {
  padding: 0.16rem 0 0.16rem 0.36rem;
}
.books {
  width: calc(100vw - 3.5rem);
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 3.5rem;
}

.card {
  width: 3.2rem;
  height: 4.8rem;
  margin: 0 0.3rem 0.25rem;
}

.cover {
  width: 3.2rem;
  height: 4.4rem;
  box-shadow: 0px 0px 10px 0px rgba(132, 132, 132, 0.5);
}

.cover img {
  width: 100%;
  height: 100%;
}

.bottombar {
  display: flex;
  position: relative;
  align-items: center;
  align-self: center;
  flex-direction: row;
  height: 0.22rem;
  /* margin-top: 0.12rem; */
  justify-content: space-between;
  padding: 0.15rem 0 0.17rem;
}

.title {
  text-decoration: none;
  line-height: 0.22rem;
  letter-spacing: 0px;
  white-space: nowrap;
  color: #474747;
  font-size: 0.2rem;
  align-self: baseline;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>